/* eslint-disable prettier/prettier */
import React from 'react';
import Layout from '@/components/Layout';
import Halo from '@/components/Halo';
import { Box, Container, Divider, Flex, Text } from 'theme-ui';
import Rings from '@/components/Rings';

function Services() {
  return (
    <Layout>
      <Halo
        title="Services"
        description="Product Design agency with Makers"
        image=""
        url=""
        author="Muneef Hameed"
      />
      <Box
        sx={{
          minHeight: [`70vh`, `73vh`, `73vh`],
          borderBottomColor: `grays.4`,
          maxWidth: [`90vw`, `80vw`, `93vw`],
          marginLeft: [`auto`, `auto`, `auto`],
          marginRight: [`0px`, `0px`, `0.1px`],
          px: [0, 4, 0],
          pt: [8, 0, 7],
          display: `flex`,
          alignItems: `center`,
          justifyContent: `space-between`,
          flexWrap: `wrap`,
          overflow: `hidden`,
        }}
      >
        <Box
          sx={{
            p: 0,
            m: 0,
            mt: -7,
            flex: [`0.7`, `0.5`, `0.5`],
          }}
        >
          <Text
            as="p"
            sx={{
              mb: 4,
              fontSize: `15px`,
              fontWeight: 400,
              color: `grays.8`,
            }}
          >
            Services
          </Text>
          <Text
            as="p"
            variant="pageDesc"
            sx={{
              mb: 4,
              fontSize: `23.44px`,
              fontWeight: 400,
              color: `grays.8`,
            }}
            id="design"
          >
            At Functionary Labs, we follow &quot;Lean Product Development&quot;
            - A method for developing products that focuses on reducing waste,
            speeding up delivery, and increasing profit and customer value.
          </Text>
        </Box>
        <Box
          sx={{
            flex: 0.7,
            overflow: `hidden`,
            height: `73vh`,
            position: [`absolute`, `relative`, `relative`],
            maxWidth: `89vw`,
            // '@media screen and (max-width: 720px)': {
            //   position: `absolute`,
            //   top: `-2vh`,
            // },
          }}
        >
          <Rings />
        </Box>
      </Box>
      <Container sx={{ scrollBehavior: `smooth` }}>
        <Flex>
          <Box
            sx={{
              flex: `0.2`,
              height: `25vh`,
              minHeight: `200px`,
              overflow: `auto`,
              position: `sticky`,
              top: `20%`,
              '@media screen and (max-width: 720px)': {
                display: `none`,
              },
            }}
          >
            <Flex
              sx={{
                flexDirection: `column`,
                alignItems: `flex-start`,
                justifyContent: `center`,
              }}
            >
              <a href="#design">
                <Text
                  as="p"
                  sx={{
                    mb: 4,
                    fontSize: `18.75px`,
                    fontWeight: 400,
                    color: `Acolor`,
                    '::selection': {
                      backgroundColor: `background`,
                    },
                  }}
                >
                  Design
                </Text>
              </a>

              <a href="#build">
                <Text
                  as="p"
                  sx={{
                    mb: 4,
                    fontSize: `18.75px`,
                    fontWeight: 400,
                    color: `Acolor`,
                  }}
                >
                  Build
                </Text>
              </a>

              <a href="#operate">
                <Text
                  as="p"
                  sx={{
                    mb: 4,
                    fontSize: `18.75px`,
                    fontWeight: 400,
                    color: `Acolor`,
                  }}
                >
                  Operate
                </Text>
              </a>
            </Flex>
          </Box>
          <Box sx={{ flex: `0.8` }}>
            <Box sx={{ maxWidth: [`100%`, `60%`, `60%`] }}>
              <Text as="h1" sx={{ marginBottom: `10px` }}>
                Design
              </Text>
              <Box>
                <Text
                  sx={{
                    color: `hover`,
                    lineHeight: `body`,
                  }}
                >
                  Based on the discovery, a usable interactive prototype of the
                  application will be developed. This enables both parties to
                  put in thoughts and test practical implications and users
                  perspective of the application. We’ll test the applications
                  flow, and usability in different aspects. This process
                  includes following activities:
                </Text>
              </Box>
              <Box
                sx={{
                  display: `flex`,
                  flexDirection: `column`,
                  gap: `30px`,
                  mt: 5,
                }}
              >
                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `1`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px dashed #C6C6C6`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`80vh`, `80vh`, `50vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Brand Sprints
                    </Text>
                    <Text
                      sx={{
                        fontWeight: `400`,
                        fontSize: `18.75`,
                        color: `Acolor`,
                      }}
                    >
                      A brand sprint is an expressive exercise that helps turn
                      ideas about your brand into a defined brand image.
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `16`,
                      // "::before": {
                      //   content: `""`,
                      //   display: `block`,
                      //   position: `absolute`,
                      //   zIndex: `1`,
                      //   top: `100%`,
                      //   left: `50%`,
                      //   border: `10px dashed #AEAEAE`,
                      //   borderWidth: `0 0 0 2px`,
                      //   width: `1px`,
                      //   height: [`130px`],
                      // }
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Stakeholder Interviews
                    </Text>
                    <Text
                      sx={{
                        fontWeight: `400`,
                        fontSize: `18.75`,
                        color: `Acolor`,
                      }}
                    >
                      We will hold discussions/interviews with business
                      stakeholders and other relevant business/user groups to
                      clarify the business goals and identify supplemental user
                      information.
                    </Text>
                  </Box>
                </Box>
                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `1`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `100`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px solid`,
                        borderColor: `base`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`48vh`, `38vh`, `28vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Competitive Analysis
                    </Text>
                    <Text
                      sx={{
                        fontWeight: `400`,
                        fontSize: `18.75`,
                        color: `Acolor`,
                      }}
                    >
                      We will review competitor apps to identify where Cane
                      vista needs to be positioned within the competitive
                      landscape, work with the team to identify site
                      likes/dislikes and do a high-level SWOT analysis
                      (Strengths, Weaknesses, Opportunities,Threats)
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Divider
              sx={{
                color: `Dcolor`,
                maxWidth: [`90vw`, `80vw`, `85vw`],
                marginLeft: `auto`,
                marginRight: `auto`,
                mt: 7,
                mb: 7,
              }}
              id="build"
            />
            <Box sx={{ maxWidth: [`100%`, `60%`, `60%`] }}>
              <Text as="h1" sx={{ marginBottom: `10px` }}>
                Define and Prototyping
              </Text>
              <Box>
                <Text sx={{ color: `hover`, lineHeight: `body` }}>
                  Based on the discovery, a usable interactive prototype of the
                  application will be developed. This enables both parties to
                  put in thoughts and test practical implications and users
                  perspective of the application. We’ll test the applications
                  flow, and usability in different aspects. This process
                  includes following activities:
                </Text>
              </Box>
              <Box
                sx={{
                  display: `flex`,
                  flexDirection: `column`,
                  gap: `30px`,
                  mt: 5,
                }}
              >
                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `1`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px dashed #C6C6C6`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`85vh`, `73vh`, `56vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Design Sprints
                    </Text>
                    <Text
                      sx={{
                        fontWeight: `400`,
                        fontSize: `18.75`,
                        color: `Acolor`,
                      }}
                    >
                      The sprint is a five-day process for answering critical
                      business questions through design, prototyping, and
                      testing ideas with customers. Developed at Google
                      Ventures, it’s a “greatest hits” of business strategy,
                      innovation, behavior science,design thinking, and
                      more—packaged into a battle-tested process that any team
                      can use.
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `16`,
                      // "::before": {
                      //   content: `""`,
                      //   display: `block`,
                      //   position: `absolute`,
                      //   zIndex: `1`,
                      //   top: `100%`,
                      //   left: `50%`,
                      //   border: `10px dashed #AEAEAE`,
                      //   borderWidth: `0 0 0 2px`,
                      //   width: `1px`,
                      //   height: [`130px`],
                      // }
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Journey Map
                    </Text>
                    <Text
                      sx={{
                        fontWeight: `400`,
                        fontSize: `18.75`,
                        color: `Acolor`,
                      }}
                    >
                      A timeline of user actions that describes the relationship
                      between your brand and your customers. We will visualize
                      all of a user’s interactions with your product, from their
                      point of view.
                    </Text>
                  </Box>
                </Box>
                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `1`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `100`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px solid`,
                        borderColor: `base`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`48vh`, `38vh`, `28vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Prototyping
                    </Text>
                    <Text
                      sx={{
                        fontWeight: `400`,
                        fontSize: `18.75`,
                        color: `Acolor`,
                      }}
                    >
                      We believe in early prototyping, and validating our
                      assumptions from real users, With prototyping, we will
                      have realistic understanding of how our users would
                      interact with your application.
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Divider
              sx={{
                color: `Dcolor`,
                maxWidth: [`90vw`, `80vw`, `85vw`],
                marginLeft: `auto`,
                marginRight: `auto`,
                mt: 7,
                mb: 7,
              }}
            />
            <Box sx={{ maxWidth: [`100%`, `60%`, `60%`] }}>
              <Text as="h1" sx={{ marginBottom: `10px` }}>
                Design and Validate
              </Text>
              <Box>
                <Text sx={{ color: `hover`, lineHeight: `body` }}>
                  This phase involves building a Interaction Design and Visual
                  Elements for the product based on the prototype - which is
                  shared with the team for feedbacks on interactions and flow -
                  feedbacks are validated and applied on the next iteration of
                  the sprint.
                </Text>
              </Box>

              <Box
                sx={{
                  display: `flex`,
                  flexDirection: `column`,
                  gap: `30px`,
                  mt: 5,
                }}
              >
                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `1`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `100`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px dashed #C6C6C6`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`65vh`, `38vh`, `35vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Identity
                    </Text>
                    <Text
                      sx={{
                        fontWeight: `400`,
                        fontSize: `18.75`,
                        color: `Acolor`,
                      }}
                    >
                      Forming a strong, memorable narrative is critical for
                      thriving businesses. we will work through our process to
                      build and form,identity guidelines for the application.
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `1`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `100`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px solid`,
                        borderColor: `base`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`48vh`, `38vh`, `28vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Design System
                    </Text>
                    <Text
                      sx={{
                        fontWeight: `400`,
                        fontSize: `18.75`,
                        color: `Acolor`,
                      }}
                    >
                      We thrive to make design consistent and reusable . Our
                      deliverables include reusable, components, that makes
                      future product design faster, and maintainable.
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Divider
              sx={{
                color: `Dcolor`,
                maxWidth: [`90vw`, `80vw`, `85vw`],
                marginLeft: `auto`,
                marginRight: `auto`,
                mt: 7,
                mb: 7,
              }}
            />
            <Box sx={{ maxWidth: [`100%`, `60%`, `60%`] }}>
              <Text as="h1" sx={{ marginBottom: `10px` }}>
                Application Development
              </Text>
              <Box>
                <Text sx={{ color: `hover`, lineHeight: `body` }}>
                  Our team follows Extreme Programming principles, were our
                  developers emphasis on pair-programming, write testable code,
                  and maintaining strict style guides.This phase involves
                  following activity.
                </Text>
              </Box>
              <Box
                sx={{
                  display: `flex`,
                  flexDirection: `column`,
                  gap: `30px`,
                  mt: 5,
                }}
              >
                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `1`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px dashed #C6C6C6`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`40vh`, `30vh`, `35vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Frontend Development
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `16`,
                      // "::before": {
                      //   content: `""`,
                      //   display: `block`,
                      //   position: `absolute`,
                      //   zIndex: `1`,
                      //   top: `100%`,
                      //   left: `50%`,
                      //   border: `10px dashed #AEAEAE`,
                      //   borderWidth: `0 0 0 2px`,
                      //   width: `1px`,
                      //   height: [`60px`],
                      // }
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Backend Development
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `16`,
                      // "::before": {
                      //   content: `""`,
                      //   display: `block`,
                      //   position: `absolute`,
                      //   zIndex: `1`,
                      //   top: `100%`,
                      //   left: `50%`,
                      //   border: `10px dashed #AEAEAE`,
                      //   borderWidth: `0 0 0 2px`,
                      //   width: `1px`,
                      //   height: [`60px`],
                      // }
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Mobile Application Development
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `1`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `100`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px solid`,
                        borderColor: `base`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`48vh`, `38vh`, `28vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Architecture
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Divider
              sx={{
                color: `Dcolor`,
                maxWidth: [`90vw`, `80vw`, `85vw`],
                marginLeft: `auto`,
                marginRight: `auto`,
                mt: 7,
                mb: 7,
              }}
              id="operate"
            />
            <Box sx={{ maxWidth: [`100%`, `60%`, `60%`], mb: 7 }}>
              <Text as="h1" sx={{ marginBottom: `10px` }}>
                Maintenance & Support
              </Text>
              <Box>
                <Text sx={{ color: `hover`, lineHeight: `body` }}>
                  We provides dedicated Technical team for the continued
                  development, support and maintenance of the application which
                  involves:
                </Text>
              </Box>
              <Box
                sx={{
                  display: `flex`,
                  flexDirection: `column`,
                  gap: `30px`,
                  mt: 5,
                }}
              >
                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `1`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px dashed #C6C6C6`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`55vh`, `50vh`, `48vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Resource augmentation
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `16`,
                      // "::before": {
                      //   content: `""`,
                      //   display: `block`,
                      //   position: `absolute`,
                      //   zIndex: `1`,
                      //   top: `100%`,
                      //   left: `50%`,
                      //   border: `10px dashed #AEAEAE`,
                      //   borderWidth: `0 0 0 2px`,
                      //   width: `1px`,
                      //   height: [`60px`],
                      // }
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Infrastructure maintenance (Devpos)
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `16`,
                      // "::before": {
                      //   content: `""`,
                      //   display: `block`,
                      //   position: `absolute`,
                      //   zIndex: `1`,
                      //   top: `100%`,
                      //   left: `50%`,
                      //   border: `10px dashed #AEAEAE`,
                      //   borderWidth: `0 0 0 2px`,
                      //   width: `1px`,
                      //   height: [`60px`],
                      // }
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      System design
                    </Text>
                  </Box>
                </Box>

                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `16`,
                      // "::before": {
                      //   content: `""`,
                      //   display: `block`,
                      //   position: `absolute`,
                      //   zIndex: `1`,
                      //   top: `100%`,
                      //   left: `50%`,
                      //   border: `10px dashed #AEAEAE`,
                      //   borderWidth: `0 0 0 2px`,
                      //   width: `1px`,
                      //   height: [`60px`],
                      // }
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Technology stewardship
                    </Text>
                  </Box>
                </Box>
                <Box sx={{ display: `flex`, gap: `10px` }}>
                  <Box
                    sx={{
                      height: `15px`,
                      width: `15px`,
                      backgroundColor: `#F0F0F0`,
                      borderRadius: `50%`,
                      mt: `6px`,
                      position: `relative`,
                      border: `1px solid #AEAEAE`,
                      zIndex: `1`,
                      '::before': {
                        content: `""`,
                        display: `block`,
                        position: `absolute`,
                        zIndex: `100`,
                        top: `100%`,
                        left: `48%`,
                        border: `10px solid`,
                        borderColor: `base`,
                        borderWidth: `0 0 0 2px`,
                        width: `1px`,
                        height: [`48vh`, `38vh`, `28vh`],
                      },
                    }}
                  >
                    {}
                  </Box>
                  <Box
                    sx={{ display: `flex`, flexDirection: `column`, flex: `1` }}
                  >
                    <Text
                      sx={{ mb: 3, fontSize: `18.75px`, fontWeight: `500` }}
                    >
                      Team Building (Agile ready team)
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Flex>
      </Container>
    </Layout>
  );
}

export default Services;
